import {createRoot} from 'react-dom/client';
import App from '~/apps/App.js';
import routes from './routes.js';

if (document.getElementById('root'))
    createRoot(document.getElementById('root')).render(
        <App routes={routes}/>
    );